import { editableAnatomy as parts } from "@chakra-ui/anatomy"
import type {
  PartsStyleObject,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"
import { $color } from "@/utils/cssVarUtils"

const baseStylePreview: SystemStyleObject = {
  py: '3xs',
  fontSize: 'sm',
}

const baseStyleInput: SystemStyleObject = {
  borderRadius: '0.333333em',
  fontSize: 'sm',
  py: '3xs',

  border: "none",
  bg: 'transparent',
  boxShadow: `inset 0 0 0 1px ${$color('bg-input-normal')}`,
  outline: 'none',
  _focus: {
    boxShadow: `inset 0 0 0 1px ${$color('scene-primary-active')}`,
  },
  _hover: {
    bg: '',
  },
}

const baseStyleTextarea: SystemStyleObject = {
  ...baseStyleInput,
  h: 'auto',
}

const baseStyle: PartsStyleObject<typeof parts> = {
  preview: baseStylePreview,
  input: baseStyleInput,
  textarea: baseStyleTextarea,
}

export const Editable = {
  parts: parts.keys,
  baseStyle,
}